import env from 'env';
import axios from 'axios';
import Qs from 'qs';

const qwReports = axios.create({
  baseURL: env.qwReportsUrl,
  responseType: 'blob',
  withCredentials: true,
  headers: {
    Accept: 'application/csv',
    'Content-Type': 'application/csv',
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

let store;
export function setStore(s) {
  store = s;
  s.subscribe(listener);
}

function select(state) {
  return state.account.user && state.account.user.accessToken;
}

function listener() {
  let token = select(store.getState());

  qwReports.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export default qwReports;
